<template>
    <div class="search-filters">
        <div class="search-filters__filter">
            Что искать?
            <div class="checkboxes ml16">
                <div class="checkbox">
                    <input type="checkbox" id="blank" 
                        @change="toggleRuleTypeToSearch(1)"
                        :checked="ruleTypesToSearch.includes(1)"
                        :class="{ error: ruleTypeError, repeatError: ruleTypeRepeatError }">
                    <label for="blank">Заготовка</label>
                </div>
                <div class="checkbox ml16">
                    <input type="checkbox" id="draft" 
                        @change="toggleRuleTypeToSearch(2)"
                        :checked="ruleTypesToSearch.includes(2)"
                        :class="{ error: ruleTypeError, repeatError: ruleTypeRepeatError }">
                    <label for="draft">Черновик</label>
                </div>
                <div class="checkbox ml16">
                    <input type="checkbox" id="ruleType" 
                        @change="toggleRuleTypeToSearch(4)"
                        :checked="ruleTypesToSearch.includes(4)"
                        :class="{ error: ruleTypeError, repeatError: ruleTypeRepeatError }">
                    <label for="ruleType">Правило</label>
                </div>
                <div class="checkbox ml16" v-if="userHasRights">
                    <input type="checkbox" id="archive" 
                        @change="toggleRuleTypeToSearch(5)"
                        :checked="ruleTypesToSearch.includes(5)"
                        :class="{ error: ruleTypeError, repeatError: ruleTypeRepeatError }">
                    <label for="archive">Архивное</label>
                </div>
            </div>
        </div>
        <div class="search-filters__filter">
            Где искать?
            <div class="checkboxes ml16">
                <div class="checkbox">
                    <input type="radio" id="all" name="section"
                        @change="setSectionToSearch(undefined)"
                        :checked="sectionToSearch === undefined || sectionToSearch != activeTopSection">
                    <label for="all">Везде</label>
                </div>
                <div class="checkbox ml16">
                    <input type="radio" id="current" name="section"
                        @change="setSectionToSearch(activeTopSection)"
                        :checked="sectionToSearch !== undefined">
                    <label for="current">В текущем разделе «<span class="text-uppercase">{{curTopSection.name}}</span>»</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: "SearchFilters",
    mounted() {
        this.$store.dispatch('rules/setRulesTypeToSearch', this.userHasRights ? [1, 2, 4, 5] : [1, 2, 4]);
    },
    computed: {
        ...mapState({
            ruleTypesToSearch: state => state.rules.ruleTypesToSearch,
            sectionToSearch: state => state.rules.sectionToSearch,
            ruleTypeError: state => state.rules.ruleTypeError,
            ruleTypeRepeatError: state => state.rules.ruleTypeRepeatError,
            topSections: state => state.rules.topSections,
            user: state => state.users.user,
        }),
        activeTopSection() {
            return  this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
        },
        curTopSection (){
            if(!this.topSections[0]) return false;

            for (let i in this.topSections) {
            if(this.topSections[i].id == this.activeTopSection){
                return this.topSections[i];
            }
            }
            return this.topSections[0];
        },
        userHasRights() {
            return this.user.access_rights.is_owner || this.user.is_chef || this.user.access_rights.is_tech_writer;
        },
    },
    methods: {
        ...mapActions('rules', ['toggleRuleTypeToSearch', 'setSectionToSearch'])
    },
}
</script>

<style scoped>
</style>